import { takeLatest, put, call } from 'redux-saga/effects'
import { postRequest } from '../../../../utils/User/axios'
import { orderRequest, orderRequestSuccess, orderRequestFailed } from '../Reducer'

export default function* orderWatcherSaga() {
  yield takeLatest(orderRequest.type, orderSaga)
}

const orderPost = (data) => {
  postRequest(`${ process.env.REACT_APP_URL }/orderAll`, data)
}

function* orderSaga({ payload }) {
  try {
    const { history } = payload
    // eslint-disable-next-line no-param-reassign
    delete payload[ history ]
    const response = yield call(orderPost, payload)
    yield put(orderRequestSuccess(response))
    history.push('/orders')
    localStorage.removeItem('orderList')
  } catch (error) {
    yield put(orderRequestFailed(error))
  }
}
